<template>
	<div>
		<el-dialog title="课程包配置" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
			<p>课程包配置：{{ form.bundleName }}</p>
			<p>每种等级技能可以配置多个课程组，每个课程组可以配置多个课程（满足其一即可），课程组之间需要同时满足</p>
			<div class="add-box">
				所需达标课程
				<el-button size="mini" type="primary" @click="handleAddSkillConfig">新增课程组</el-button>
			</div>
			<div>
				<table class="course-table">
					<thead>
						<tr>
							<td width="100">课程组序号</td>
							<td width="180">课程配置1</td>
							<td width="180">或课程配置2</td>
							<td width="180">或课程配置3</td>
							<td width="180">或课程配置4</td>
							<td width="180">或课程配置5</td>
							<td width="180">或课程配置6</td>
							<td width="180">或课程配置7</td>
							<td width="100">操作</td>
						</tr>
					</thead>
					<tr v-for="(value, i) in clist">
						<td align="center">{{ i + 1 }}</td>
						<td v-html="formatText(value[1])"></td>
						<td v-html="formatText(value[2])"></td>
						<td v-html="formatText(value[3])"></td>
						<td v-html="formatText(value[4])"></td>
						<td v-html="formatText(value[5])"></td>
						<td v-html="formatText(value[6])"></td>
						<td v-html="formatText(value[7])"></td>
						<td>
							<el-button size="mini" type="text" @click="handleEditSkillConfig(value[0])">编辑</el-button>
							<el-button size="mini" type="text" @click="handleDel(value[0])">删除</el-button>
						</td>
					</tr>
				</table>
			</div>
			<div class="bottom-box">
				最低需要满足
				<el-input size="mini" v-model="form.minGroupCount" placeholder="请输入内容"></el-input>
				组
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
		<skill-config-detail-dialog ref="skillConfigDetailDialogRef" @refresh="getCourseSkillBundleConfigDetailList" />
	</div>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { courseSkillBundleAdd, courseSkillBundleUpdate, courseSkillBundleConfigDetailGetAll, courseSkillBundleConfigDetailDel } from "@/api/skill";
import SkillConfigDetailDialog from "./SkillConfigDetailDialog.vue";
export default {
	components: {
		SkillConfigDetailDialog,
	},
	data() {
		return {
			dialogVisible: false,
			submitLoading: false,
			form: {
				id: "",
				skillId: "",
				bundleName: "",
				bundleCode: "",
				minGroupCount: 0,
			},
			clist: [],
		};
	},
	methods: {
		// 初始化弹窗
		init(dt) {
			this.dialogVisible = true;
			this.submitLoading = false;
			this.form = {
				id: dt.id,
				skillId: dt.skillId,
				bundleName: dt.bundleName,
				bundleCode: dt.bundleCode,
				minGroupCount: dt.minGroupCount,
			};
			this.getCourseSkillBundleConfigDetailList();
		},
		formatText(text) {
			if (!text || typeof text !== "string") return "";
			return text.replace(/ and /g, '<br><span style="color: #FF6B35;"> and </span><br>');
		},
		// 关闭弹窗
		handleClose() {
			this.dialogVisible = false;
			this.submitLoading = true;
		},
		// 新增课程组
		handleAddSkillConfig() {
			this.$refs.skillConfigDetailDialogRef.init(this.form.id, this.form.skillId);
		},
		// 编辑课程组
		handleEditSkillConfig(groupId) {
			this.$refs.skillConfigDetailDialogRef.init(this.form.id, this.form.skillId, groupId);
		},
		// 删除课程组
		handleDel(groupId) {
			this.$confirm(`确认删除吗？`, "提示", { type: "warning" }).then(() => {
				courseSkillBundleConfigDetailDel({ id: groupId }).then((res) => {
					if (res.code != "0") return this.$message.error(res.msg);
					this.$message.success("删除成功");
					this.getCourseSkillBundleConfigDetailList();
				});
			});
		},
		// 获取课程组列表
		getCourseSkillBundleConfigDetailList() {
			courseSkillBundleConfigDetailGetAll({ bundleId: this.form.id }).then((res) => {
				this.clist = res.data.map((item) => ({ ...item, length: 7 }));
			});
		},
		// 提交表单
		handleSubmit: debounce(function () {
			if (this.submitLoading) return;
			this.handleClose();
			const api = this.form.id ? courseSkillBundleUpdate : courseSkillBundleAdd;
			const msg = this.form.id ? "编辑成功" : "新增成功";
			api(this.form).then((res) => {
				this.submitLoading = false;
				if (res.code != "0") return this.$message.error(res.msg);
				this.$message.success(msg);

				this.$emit("refresh", this.form.skillId);
			});
		}, 300),
	},
};
</script>

<style lang="scss" scoped>
.course-table {
	border-collapse: collapse;
	border-spacing: 0;
	table-layout: fixed;
	thead {
		td {
			text-align: center;
		}
	}
	tr {
		td {
			font-size: 12px;
			border: 1px solid #333;
			padding: 8px;
			color: #000;
		}
	}
}
.add-box {
	margin: 10px 0;
}
.bottom-box {
	display: flex;
	align-items: center;
	margin-top: 10px;
	.el-input {
		width: 80px;
		margin: 0 5px;
	}
}
</style>
